import { render } from "./ExamAiAssistantTab.vue?vue&type=template&id=63bf9744&scoped=true"
import script from "./ExamAiAssistantTab.js?vue&type=script&lang=js&external"
export * from "./ExamAiAssistantTab.js?vue&type=script&lang=js&external"

import "./ExamAiAssistantTab.scss?vue&type=style&index=0&id=63bf9744&lang=scss&scoped=true&external"
import "./ExamAiAssistantTab.vue?vue&type=style&index=1&id=63bf9744&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bf9744"]])

export default __exports__